import { PhoneCall, CalendarCheck, BadgeCheck } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    icon: PhoneCall,
    title: "Ci contatti",
    text: "Chiamaci, scrivici su WhatsApp o compila il modulo: descrivi il problema in due minuti.",
  },
  {
    n: "02",
    icon: CalendarCheck,
    title: "Fissiamo l'intervento",
    text: "Ti diamo subito un preventivo gratuito e concordiamo giorno e ora comodi per te.",
  },
  {
    n: "03",
    icon: BadgeCheck,
    title: "Risolviamo a casa tua",
    text: "Il tecnico arriva con ricambi e attrezzatura: la maggior parte dei guasti si risolve in una visita.",
  },
];

export const Process = () => (
  <section id="come-funziona" data-testid="process-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <FadeUp>
        <Eyebrow>Come funziona</Eyebrow>
        <h1 className="font-display font-semibold tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4">
          Tre passi.
          <span className="text-[#94A3B8]"> Niente pensieri.</span>
        </h1>
      </FadeUp>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
        {STEPS.map((s, i) => (
          <FadeUp key={s.n} delay={i * 0.12}>
            <div
              data-testid={`process-step-${s.n}`}
              className="relative rounded-3xl border border-white/10 p-8 md:p-10 h-full overflow-hidden transition-all duration-300 hover:border-white/25 group"
            >
              <span className="font-mono-tech text-7xl md:text-8xl font-bold text-white/[0.06] absolute -top-3 right-4 select-none transition-colors duration-500 group-hover:text-[#FF6B00]/15">
                {s.n}
              </span>
              <s.icon className="w-7 h-7 text-[#FF6B00] mb-8 relative" />
              <h3 className="font-display font-semibold text-xl md:text-2xl tracking-tight mb-3 relative">
                {s.title}
              </h3>
              <p className="text-sm md:text-base text-[#94A3B8] leading-relaxed relative">
                {s.text}
              </p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
